(function () {
  var WARNING_ATTR = 'data-warning-message';
  var ACK_ATTR = 'data-warning-ack';
  var text = window.cartWarningPopupText || {};
  var cancelLabel = text.cancel || 'Cancel';
  var confirmLabel = text.confirm || 'Add to Cart';

  var style = document.createElement('style');
  style.textContent =
    '.cart-warning-modal-overlay{position:fixed;inset:0;' +
    'background:rgba(0,0,0,var(--cart-warning-overlay-opacity,0.4));' +
    'display:flex;align-items:center;justify-content:center;z-index:9999;padding:1.25rem;}' +
    '.cart-warning-modal{background:var(--cart-warning-bg,#fff);color:var(--cart-warning-text,#1a1a1a);' +
    'max-width:var(--cart-warning-width,500px);width:100%;max-height:85vh;overflow-y:auto;' +
    'border:1px solid rgba(0,0,0,.08);' +
    'border-radius:var(--cart-warning-radius,10px);padding:2rem;' +
    'box-shadow:0 8px 28px rgba(0,0,0,.14);}' +
    '.cart-warning-modal__message{margin:0 0 1.5rem;line-height:1.6;white-space:pre-line;font-size:15px;}' +
    '.cart-warning-modal__actions{display:flex;gap:.6rem;justify-content:center;}' +
    '.cart-warning-modal__cancel,.cart-warning-modal__confirm{' +
    'padding:var(--cart-warning-button-pad-y,10px) var(--cart-warning-button-pad-x,20px);' +
    'font-size:var(--cart-warning-button-font,13px);}' +
    '.cart-warning-modal__confirm{background:var(--cart-warning-confirm-bg,#2b2b2b);' +
    'color:var(--cart-warning-confirm-text,#fff);border-color:transparent;}' +
    '@media (max-width:480px){' +
    '.cart-warning-modal{padding:1.5rem;}' +
    '.cart-warning-modal__message{font-size:14px;}' +
    '.cart-warning-modal__actions{flex-direction:column-reverse;gap:.5rem;}' +
    '.cart-warning-modal__cancel,.cart-warning-modal__confirm{width:100%;text-align:center;padding:.85rem 1rem;}' +
    '}';
  document.head.appendChild(style);

  function getWarningText(form) {
    var container = form.closest('[' + WARNING_ATTR + ']');
    return container ? container.getAttribute(WARNING_ATTR) : '';
  }

  function showModal(message, onConfirm, onCancel) {
    var overlay = document.createElement('div');
    overlay.className = 'cart-warning-modal-overlay';
    overlay.innerHTML =
      '<div class="cart-warning-modal" role="alertdialog" aria-modal="true">' +
      '<p class="cart-warning-modal__message"></p>' +
      '<div class="cart-warning-modal__actions">' +
      '<button type="button" class="button button--secondary cart-warning-modal__cancel"></button>' +
      '<button type="button" class="button cart-warning-modal__confirm"></button>' +
      '</div></div>';
    overlay.querySelector('.cart-warning-modal__message').textContent = message;
    overlay.querySelector('.cart-warning-modal__cancel').textContent = cancelLabel;
    overlay.querySelector('.cart-warning-modal__confirm').textContent = confirmLabel;

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKeydown);
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); onCancel && onCancel(); }
    }

    overlay.querySelector('.cart-warning-modal__confirm').addEventListener('click', function () {
      close(); onConfirm();
    });
    overlay.querySelector('.cart-warning-modal__cancel').addEventListener('click', function () {
      close(); onCancel && onCancel();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { close(); onCancel && onCancel(); }
    });
    document.addEventListener('keydown', onKeydown);

    document.body.appendChild(overlay);
    overlay.querySelector('.cart-warning-modal__confirm').focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    if (form.hasAttribute(ACK_ATTR)) {
      form.removeAttribute(ACK_ATTR);
      return;
    }

    var message = getWarningText(form);
    if (!message) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    showModal(message, function () {
      form.setAttribute(ACK_ATTR, 'true');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(form.querySelector('[type="submit"]'));
      } else {
        form.submit();
      }
    });
  }, true);
})();
